// GetStartedSection.jsx
// Desktop: dark full-width banner, left text + right kids image
// Mobile: stacked - text first, image below
import child from "../Assests/Untitled design (1).png"

const IMG_KIDS = child;

const FeatureRow = ({ icon, title, desc }) => (
  <div className="flex items-start gap-4 mb-5">
    <div className="w-12 h-12 rounded-full bg-[#1a2a3a] border border-[#2a3a52] flex items-center justify-center flex-shrink-0">
      {icon}
    </div>
    <div>
      <p className="font-extrabold text-white text-base">{title}</p>
      <p className="text-gray-400 text-sm mt-0.5">{desc}</p>
    </div>
  </div>
);

const TeacherIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5" stroke="white" strokeWidth="1.5">
    <path d="M12 12c2.7 0 5-2.3 5-5S14.7 2 12 2 7 4.3 7 7s2.3 5 5 5zm0 2c-3.3 0-10 1.7-10 5v2h20v-2c0-3.3-6.7-5-10-5z" strokeLinecap="round" />
    <path d="M17 10l1.5 1.5L22 8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const PaletteIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5" stroke="white" strokeWidth="1.5">
    <circle cx="12" cy="12" r="10" />
    <circle cx="8.5" cy="10" r="1.5" fill="white" />
    <circle cx="15.5" cy="10" r="1.5" fill="white" />
    <path d="M8.5 15c1 1.5 5.5 1.5 7 0" strokeLinecap="round" />
  </svg>
);

export default function GetStartedSection() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-16 py-10">
      <div className="max-w-7xl mx-auto bg-[#0D1B2A] rounded-3xl overflow-hidden relative">

        {/* Grid dots background */}
        <div
          className="absolute inset-0 pointer-events-none opacity-20"
          style={{
            backgroundImage: "radial-gradient(circle, #ffffff22 1px, transparent 1px)",
            backgroundSize: "28px 28px",
          }}
        />

        <div className="flex flex-col md:flex-row items-stretch relative z-10">

          {/* LEFT: Text content */}
          <div className="w-full md:w-1/2 p-8 md:p-12 lg:p-16 flex flex-col justify-center">

            {/* Label */}
            <div className="inline-flex items-center gap-2 border border-gray-600 rounded-full px-4 py-1 text-sm font-medium text-gray-300 mb-6 w-fit bg-[#1a2a3a]">
              <span className="text-[#FF6B35] font-black text-lg">✦</span>
              Get Started Today
            </div>

            <h2 className="text-3xl md:text-4xl font-extrabold text-white leading-tight mb-4">
              Let's connect and begin your child's learning adventure
            </h2>

            <p className="text-gray-400 text-sm leading-relaxed mb-8">
              Take the first step toward a joyful, nurturing, and enriching learning experience for your child.
              Reach out to us today, and our friendly team will guide you through admissions, programs, and
              everything you need to begin this exciting educational journey.
            </p>

            <FeatureRow
              icon={<TeacherIcon />}
              title="Child-Centered Learning"
              desc="We design every activity, lesson, and environment around each child."
            />
            <FeatureRow
              icon={<PaletteIcon />}
              title="Regular Progress Updates"
              desc="We design every activity, lesson, and environment around each child."
            />

            <button
            onClick={() => window.location.href = "/contact"}
            className="mt-4 w-fit bg-[#FF6B35] text-white font-extrabold px-8 py-3 rounded-full flex items-center gap-2 hover:bg-[#e55a24] transition-colors text-sm">
              Get Started
              <span className="bg-white/20 rounded-full w-6 h-6 flex items-center justify-center text-xs">→</span>
            </button>
          </div>

          {/* RIGHT: Kids image */}
          <div className="w-full md:w-1/2 relative flex items-end justify-center">
            {/* Orange dot */}
            {/* <div className="absolute top-12 left-6 w-3 h-3 rounded-full bg-[#FF6B35]" /> */}

            <img
              src={IMG_KIDS}
              alt="Kids holding sign"
            //   className="w-full h-74 md:h-full object-cover md:rounded-none rounded-2xl"
              style={{ maxHeight: '480px' }}
            />

            {/* Sign overlay on desktop */}
            <div className="hidden md:block absolute bottom-8 left-1/2 -translate-x-1/2 bg-[#e8d8b0] rounded-xl px-6 py-4 text-center shadow-xl">
              <p className="font-extrabold text-[#0D1B2A] text-lg leading-tight">
                Your Child's Bright Start<br />Begins Here!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}